import { render, staticRenderFns } from "./PreloaderView.vue?vue&type=template&id=11e64a3e&"
import script from "./PreloaderView.vue?vue&type=script&lang=js&"
export * from "./PreloaderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports